import { Block } from './Block'
import { Rule } from './Rule'

export const ValidationRule = {
  Block,
  Rule
}
